/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetPodMutatorInstallCmdResponse } from '../models';
// @ts-ignore
import type { ListPodMutationsResponse } from '../models';
// @ts-ignore
import type { ListWorkloadPreviewsResponse } from '../models';
// @ts-ignore
import type { LongRunningOperation } from '../models';
// @ts-ignore
import type { PodMutation } from '../models';
// @ts-ignore
import type { PodMutatorStatus } from '../models';
// @ts-ignore
import type { PreviewMatchedWorkloadsRequest } from '../models';
// @ts-ignore
import type { PreviewMatchedWorkloadsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { WorkloadPreviewParameters } from '../models';
/**
 * PodMutationsAPIApi - axios parameter creator
 * @export
 */
export const PodMutationsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a pod mutation.
         * @summary Create a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {PodMutation} podMutation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPICreatePodMutation: async (organizationId: string, clusterId: string, podMutation: PodMutation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPICreatePodMutation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPICreatePodMutation', 'clusterId', clusterId)
            // verify required parameter 'podMutation' is not null or undefined
            assertParamExists('podMutationsAPICreatePodMutation', 'podMutation', podMutation)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(podMutation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes pod mutation.
         * @summary Delete a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The pod mutation ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIDeletePodMutation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIDeletePodMutation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIDeletePodMutation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podMutationsAPIDeletePodMutation', 'id', id)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GenerateWorkloadPreviews generates an async workload preview showing which workloads would be affected by a pod mutation.
         * @summary Generate workload previews.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {WorkloadPreviewParameters} workloadPreviewParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGenerateWorkloadPreviews: async (organizationId: string, clusterId: string, workloadPreviewParameters: WorkloadPreviewParameters, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIGenerateWorkloadPreviews', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIGenerateWorkloadPreviews', 'clusterId', clusterId)
            // verify required parameter 'workloadPreviewParameters' is not null or undefined
            assertParamExists('podMutationsAPIGenerateWorkloadPreviews', 'workloadPreviewParameters', workloadPreviewParameters)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/workload-previews:generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadPreviewParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get pod mutation by ID.
         * @summary Get a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The pod mutation ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutation: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutation', 'id', id)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the command to install the pod mutator.
         * @summary Get the pod mutator installation command.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorInstallCmd: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorInstallCmd', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorInstallCmd', 'clusterId', clusterId)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}:getPodMutatorInstallCmd`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the script to install the pod mutator.
         * @summary Get the pod mutator installation script.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorInstallScript: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorInstallScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorInstallScript', 'clusterId', clusterId)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}:getPodMutatorInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of the pod mutator.
         * @summary Get the status of the pod mutator.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorStatus: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorStatus', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIGetPodMutatorStatus', 'clusterId', clusterId)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutator-status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists pod mutations. Use \"-\" wildcard to list pod mutations across all clusters.
         * @summary List pod mutations.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID. Can be set to \&quot;-\&quot; to list pod mutations across all clusters.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [enabled] If set, returns only enabled/disabled pod mutations
         * @param {boolean} [materializePatch] Returns full view of the pod mutation to apply
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIListPodMutations: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, enabled?: boolean, materializePatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIListPodMutations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIListPodMutations', 'clusterId', clusterId)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            if (materializePatch !== undefined) {
                localVarQueryParameter['materializePatch'] = materializePatch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ListWorkloadPreviews retrieves paginated workload preview results for operation_id
         * @summary List workload previews.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [operationId] Operation ID
         * @param {PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum} [workloadType] Workload type to retrieve (affected or unaffected).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {PodMutationsAPIListWorkloadPreviewsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<string>} [filterNames] Filter by workload names. Empty means no filter.
         * @param {Array<string>} [filterKinds] Filter by workload kinds. Empty means no filter.
         * @param {Array<string>} [filterNamespaces] Filter by workload namespaces. Empty means no filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIListWorkloadPreviews: async (organizationId: string, clusterId: string, operationId?: string, workloadType?: PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: PodMutationsAPIListWorkloadPreviewsSortOrderEnum, filterNames?: Array<string>, filterKinds?: Array<string>, filterNamespaces?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIListWorkloadPreviews', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIListWorkloadPreviews', 'clusterId', clusterId)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/workload-previews`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (workloadType !== undefined) {
                localVarQueryParameter['workloadType'] = workloadType;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (filterNames) {
                localVarQueryParameter['filter.names'] = filterNames;
            }

            if (filterKinds) {
                localVarQueryParameter['filter.kinds'] = filterKinds;
            }

            if (filterNamespaces) {
                localVarQueryParameter['filter.namespaces'] = filterNamespaces;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PreviewMatchedWorkloads returns a simulation of the workloads that would be matched for a specific pod mutation filters.
         * @summary Preview matched workloads.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {PreviewMatchedWorkloadsRequest} previewMatchedWorkloadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIPreviewMatchedWorkloads: async (organizationId: string, clusterId: string, previewMatchedWorkloadsRequest: PreviewMatchedWorkloadsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIPreviewMatchedWorkloads', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIPreviewMatchedWorkloads', 'clusterId', clusterId)
            // verify required parameter 'previewMatchedWorkloadsRequest' is not null or undefined
            assertParamExists('podMutationsAPIPreviewMatchedWorkloads', 'previewMatchedWorkloadsRequest', previewMatchedWorkloadsRequest)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations:previewMatchedWorkloads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewMatchedWorkloadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a pod mutation.
         * @summary Update a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The ID of the pod mutation.
         * @param {PodMutation} podMutation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIUpdatePodMutation: async (organizationId: string, clusterId: string, id: string, podMutation: PodMutation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('podMutationsAPIUpdatePodMutation', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('podMutationsAPIUpdatePodMutation', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podMutationsAPIUpdatePodMutation', 'id', id)
            // verify required parameter 'podMutation' is not null or undefined
            assertParamExists('podMutationsAPIUpdatePodMutation', 'podMutation', podMutation)
            const localVarPath = `/patching-engine/v1beta/organizations/{organizationId}/clusters/{clusterId}/pod-mutations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(podMutation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodMutationsAPIApi - functional programming interface
 * @export
 */
export const PodMutationsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodMutationsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a pod mutation.
         * @summary Create a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {PodMutation} podMutation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPICreatePodMutation(organizationId: string, clusterId: string, podMutation: PodMutation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodMutation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPICreatePodMutation(organizationId, clusterId, podMutation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPICreatePodMutation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes pod mutation.
         * @summary Delete a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The pod mutation ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIDeletePodMutation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIDeletePodMutation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIDeletePodMutation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GenerateWorkloadPreviews generates an async workload preview showing which workloads would be affected by a pod mutation.
         * @summary Generate workload previews.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {WorkloadPreviewParameters} workloadPreviewParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIGenerateWorkloadPreviews(organizationId: string, clusterId: string, workloadPreviewParameters: WorkloadPreviewParameters, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRunningOperation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIGenerateWorkloadPreviews(organizationId, clusterId, workloadPreviewParameters, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIGenerateWorkloadPreviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get pod mutation by ID.
         * @summary Get a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The pod mutation ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIGetPodMutation(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodMutation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIGetPodMutation(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIGetPodMutation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the command to install the pod mutator.
         * @summary Get the pod mutator installation command.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIGetPodMutatorInstallCmd(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPodMutatorInstallCmdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIGetPodMutatorInstallCmd(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIGetPodMutatorInstallCmd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the script to install the pod mutator.
         * @summary Get the pod mutator installation script.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIGetPodMutatorInstallScript(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIGetPodMutatorInstallScript(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIGetPodMutatorInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of the pod mutator.
         * @summary Get the status of the pod mutator.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIGetPodMutatorStatus(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodMutatorStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIGetPodMutatorStatus(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIGetPodMutatorStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists pod mutations. Use \"-\" wildcard to list pod mutations across all clusters.
         * @summary List pod mutations.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID. Can be set to \&quot;-\&quot; to list pod mutations across all clusters.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [enabled] If set, returns only enabled/disabled pod mutations
         * @param {boolean} [materializePatch] Returns full view of the pod mutation to apply
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIListPodMutations(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, enabled?: boolean, materializePatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPodMutationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIListPodMutations(organizationId, clusterId, pageLimit, pageCursor, enabled, materializePatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIListPodMutations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ListWorkloadPreviews retrieves paginated workload preview results for operation_id
         * @summary List workload previews.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [operationId] Operation ID
         * @param {PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum} [workloadType] Workload type to retrieve (affected or unaffected).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {PodMutationsAPIListWorkloadPreviewsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {Array<string>} [filterNames] Filter by workload names. Empty means no filter.
         * @param {Array<string>} [filterKinds] Filter by workload kinds. Empty means no filter.
         * @param {Array<string>} [filterNamespaces] Filter by workload namespaces. Empty means no filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIListWorkloadPreviews(organizationId: string, clusterId: string, operationId?: string, workloadType?: PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: PodMutationsAPIListWorkloadPreviewsSortOrderEnum, filterNames?: Array<string>, filterKinds?: Array<string>, filterNamespaces?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkloadPreviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIListWorkloadPreviews(organizationId, clusterId, operationId, workloadType, pageLimit, pageCursor, sortField, sortOrder, filterNames, filterKinds, filterNamespaces, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIListWorkloadPreviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PreviewMatchedWorkloads returns a simulation of the workloads that would be matched for a specific pod mutation filters.
         * @summary Preview matched workloads.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {PreviewMatchedWorkloadsRequest} previewMatchedWorkloadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIPreviewMatchedWorkloads(organizationId: string, clusterId: string, previewMatchedWorkloadsRequest: PreviewMatchedWorkloadsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewMatchedWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIPreviewMatchedWorkloads(organizationId, clusterId, previewMatchedWorkloadsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIPreviewMatchedWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a pod mutation.
         * @summary Update a pod mutation.
         * @param {string} organizationId The organization ID.
         * @param {string} clusterId The cluster ID.
         * @param {string} id The ID of the pod mutation.
         * @param {PodMutation} podMutation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async podMutationsAPIUpdatePodMutation(organizationId: string, clusterId: string, id: string, podMutation: PodMutation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodMutation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.podMutationsAPIUpdatePodMutation(organizationId, clusterId, id, podMutation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodMutationsAPIApi.podMutationsAPIUpdatePodMutation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PodMutationsAPIApi - factory interface
 * @export
 */
export const PodMutationsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodMutationsAPIApiFp(configuration)
    return {
        /**
         * Creates a pod mutation.
         * @summary Create a pod mutation.
         * @param {PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPICreatePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PodMutation> {
            return localVarFp.podMutationsAPICreatePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.podMutation, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes pod mutation.
         * @summary Delete a pod mutation.
         * @param {PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIDeletePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.podMutationsAPIDeletePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * GenerateWorkloadPreviews generates an async workload preview showing which workloads would be affected by a pod mutation.
         * @summary Generate workload previews.
         * @param {PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGenerateWorkloadPreviews(requestParameters: PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LongRunningOperation> {
            return localVarFp.podMutationsAPIGenerateWorkloadPreviews(requestParameters.organizationId, requestParameters.clusterId, requestParameters.workloadPreviewParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get pod mutation by ID.
         * @summary Get a pod mutation.
         * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PodMutation> {
            return localVarFp.podMutationsAPIGetPodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the command to install the pod mutator.
         * @summary Get the pod mutator installation command.
         * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorInstallCmd(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPodMutatorInstallCmdResponse> {
            return localVarFp.podMutationsAPIGetPodMutatorInstallCmd(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the script to install the pod mutator.
         * @summary Get the pod mutator installation script.
         * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorInstallScript(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.podMutationsAPIGetPodMutatorInstallScript(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of the pod mutator.
         * @summary Get the status of the pod mutator.
         * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIGetPodMutatorStatus(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PodMutatorStatus> {
            return localVarFp.podMutationsAPIGetPodMutatorStatus(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists pod mutations. Use \"-\" wildcard to list pod mutations across all clusters.
         * @summary List pod mutations.
         * @param {PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIListPodMutations(requestParameters: PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPodMutationsResponse> {
            return localVarFp.podMutationsAPIListPodMutations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.enabled, requestParameters.materializePatch, options).then((request) => request(axios, basePath));
        },
        /**
         * ListWorkloadPreviews retrieves paginated workload preview results for operation_id
         * @summary List workload previews.
         * @param {PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIListWorkloadPreviews(requestParameters: PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkloadPreviewsResponse> {
            return localVarFp.podMutationsAPIListWorkloadPreviews(requestParameters.organizationId, requestParameters.clusterId, requestParameters.operationId, requestParameters.workloadType, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.filterNames, requestParameters.filterKinds, requestParameters.filterNamespaces, options).then((request) => request(axios, basePath));
        },
        /**
         * PreviewMatchedWorkloads returns a simulation of the workloads that would be matched for a specific pod mutation filters.
         * @summary Preview matched workloads.
         * @param {PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIPreviewMatchedWorkloads(requestParameters: PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewMatchedWorkloadsResponse> {
            return localVarFp.podMutationsAPIPreviewMatchedWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.previewMatchedWorkloadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a pod mutation.
         * @summary Update a pod mutation.
         * @param {PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podMutationsAPIUpdatePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PodMutation> {
            return localVarFp.podMutationsAPIUpdatePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.podMutation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for podMutationsAPICreatePodMutation operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest
 */
export interface PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPICreatePodMutation
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPICreatePodMutation
     */
    readonly clusterId: string

    /**
     * 
     * @type {PodMutation}
     * @memberof PodMutationsAPIApiPodMutationsAPICreatePodMutation
     */
    readonly podMutation: PodMutation
}

/**
 * Request parameters for podMutationsAPIDeletePodMutation operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIDeletePodMutation
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIDeletePodMutation
     */
    readonly clusterId: string

    /**
     * The pod mutation ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIDeletePodMutation
     */
    readonly id: string
}

/**
 * Request parameters for podMutationsAPIGenerateWorkloadPreviews operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviews
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviews
     */
    readonly clusterId: string

    /**
     * 
     * @type {WorkloadPreviewParameters}
     * @memberof PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviews
     */
    readonly workloadPreviewParameters: WorkloadPreviewParameters
}

/**
 * Request parameters for podMutationsAPIGetPodMutation operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutation
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutation
     */
    readonly clusterId: string

    /**
     * The pod mutation ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutation
     */
    readonly id: string
}

/**
 * Request parameters for podMutationsAPIGetPodMutatorInstallCmd operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmd
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmd
     */
    readonly clusterId: string
}

/**
 * Request parameters for podMutationsAPIGetPodMutatorInstallScript operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScript
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScript
     */
    readonly clusterId: string
}

/**
 * Request parameters for podMutationsAPIGetPodMutatorStatus operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatus
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatus
     */
    readonly clusterId: string
}

/**
 * Request parameters for podMutationsAPIListPodMutations operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly organizationId: string

    /**
     * The cluster ID. Can be set to \&quot;-\&quot; to list pod mutations across all clusters.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly pageCursor?: string

    /**
     * If set, returns only enabled/disabled pod mutations
     * @type {boolean}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly enabled?: boolean

    /**
     * Returns full view of the pod mutation to apply
     * @type {boolean}
     * @memberof PodMutationsAPIApiPodMutationsAPIListPodMutations
     */
    readonly materializePatch?: boolean
}

/**
 * Request parameters for podMutationsAPIListWorkloadPreviews operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly clusterId: string

    /**
     * Operation ID
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly operationId?: string

    /**
     * Workload type to retrieve (affected or unaffected).
     * @type {'WORKLOAD_TYPE_UNSPECIFIED' | 'AFFECTED' | 'UNAFFECTED'}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly workloadType?: PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly sortOrder?: PodMutationsAPIListWorkloadPreviewsSortOrderEnum

    /**
     * Filter by workload names. Empty means no filter.
     * @type {Array<string>}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly filterNames?: Array<string>

    /**
     * Filter by workload kinds. Empty means no filter.
     * @type {Array<string>}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly filterKinds?: Array<string>

    /**
     * Filter by workload namespaces. Empty means no filter.
     * @type {Array<string>}
     * @memberof PodMutationsAPIApiPodMutationsAPIListWorkloadPreviews
     */
    readonly filterNamespaces?: Array<string>
}

/**
 * Request parameters for podMutationsAPIPreviewMatchedWorkloads operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloads
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloads
     */
    readonly clusterId: string

    /**
     * 
     * @type {PreviewMatchedWorkloadsRequest}
     * @memberof PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloads
     */
    readonly previewMatchedWorkloadsRequest: PreviewMatchedWorkloadsRequest
}

/**
 * Request parameters for podMutationsAPIUpdatePodMutation operation in PodMutationsAPIApi.
 * @export
 * @interface PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest
 */
export interface PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIUpdatePodMutation
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIUpdatePodMutation
     */
    readonly clusterId: string

    /**
     * The ID of the pod mutation.
     * @type {string}
     * @memberof PodMutationsAPIApiPodMutationsAPIUpdatePodMutation
     */
    readonly id: string

    /**
     * 
     * @type {PodMutation}
     * @memberof PodMutationsAPIApiPodMutationsAPIUpdatePodMutation
     */
    readonly podMutation: PodMutation
}

/**
 * PodMutationsAPIApi - object-oriented interface
 * @export
 * @class PodMutationsAPIApi
 * @extends {BaseAPI}
 */
export class PodMutationsAPIApi extends BaseAPI {
    /**
     * Creates a pod mutation.
     * @summary Create a pod mutation.
     * @param {PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPICreatePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPICreatePodMutationRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPICreatePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.podMutation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes pod mutation.
     * @summary Delete a pod mutation.
     * @param {PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIDeletePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIDeletePodMutationRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIDeletePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GenerateWorkloadPreviews generates an async workload preview showing which workloads would be affected by a pod mutation.
     * @summary Generate workload previews.
     * @param {PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIGenerateWorkloadPreviews(requestParameters: PodMutationsAPIApiPodMutationsAPIGenerateWorkloadPreviewsRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIGenerateWorkloadPreviews(requestParameters.organizationId, requestParameters.clusterId, requestParameters.workloadPreviewParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get pod mutation by ID.
     * @summary Get a pod mutation.
     * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIGetPodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutationRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIGetPodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the command to install the pod mutator.
     * @summary Get the pod mutator installation command.
     * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIGetPodMutatorInstallCmd(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallCmdRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIGetPodMutatorInstallCmd(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the script to install the pod mutator.
     * @summary Get the pod mutator installation script.
     * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIGetPodMutatorInstallScript(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIGetPodMutatorInstallScript(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of the pod mutator.
     * @summary Get the status of the pod mutator.
     * @param {PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIGetPodMutatorStatus(requestParameters: PodMutationsAPIApiPodMutationsAPIGetPodMutatorStatusRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIGetPodMutatorStatus(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists pod mutations. Use \"-\" wildcard to list pod mutations across all clusters.
     * @summary List pod mutations.
     * @param {PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIListPodMutations(requestParameters: PodMutationsAPIApiPodMutationsAPIListPodMutationsRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIListPodMutations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.enabled, requestParameters.materializePatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ListWorkloadPreviews retrieves paginated workload preview results for operation_id
     * @summary List workload previews.
     * @param {PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIListWorkloadPreviews(requestParameters: PodMutationsAPIApiPodMutationsAPIListWorkloadPreviewsRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIListWorkloadPreviews(requestParameters.organizationId, requestParameters.clusterId, requestParameters.operationId, requestParameters.workloadType, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.filterNames, requestParameters.filterKinds, requestParameters.filterNamespaces, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PreviewMatchedWorkloads returns a simulation of the workloads that would be matched for a specific pod mutation filters.
     * @summary Preview matched workloads.
     * @param {PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIPreviewMatchedWorkloads(requestParameters: PodMutationsAPIApiPodMutationsAPIPreviewMatchedWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIPreviewMatchedWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.previewMatchedWorkloadsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a pod mutation.
     * @summary Update a pod mutation.
     * @param {PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodMutationsAPIApi
     */
    public podMutationsAPIUpdatePodMutation(requestParameters: PodMutationsAPIApiPodMutationsAPIUpdatePodMutationRequest, options?: RawAxiosRequestConfig) {
        return PodMutationsAPIApiFp(this.configuration).podMutationsAPIUpdatePodMutation(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.podMutation, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum = {
    WORKLOAD_TYPE_UNSPECIFIED: 'WORKLOAD_TYPE_UNSPECIFIED',
    AFFECTED: 'AFFECTED',
    UNAFFECTED: 'UNAFFECTED'
} as const;
export type PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum = typeof PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum[keyof typeof PodMutationsAPIListWorkloadPreviewsWorkloadTypeEnum];
/**
 * @export
 */
export const PodMutationsAPIListWorkloadPreviewsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type PodMutationsAPIListWorkloadPreviewsSortOrderEnum = typeof PodMutationsAPIListWorkloadPreviewsSortOrderEnum[keyof typeof PodMutationsAPIListWorkloadPreviewsSortOrderEnum];
